import React, { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ButtonProps, Dropdown } from 'react-bootstrap';

import { logout, logoutExternal } from '../../../core/state/auth/asyncActions';
import { RootState } from '../../../core/state/state';
import Icon from '../../../components/icon/Icon';
import { history } from '../../../core/state/history';
import { UserRoleType } from '../../../core/state/user/types';
import { PROFILE } from '../../../core/constants/routes';
import Image from '../../../components/image/Image';
import defaultUserImage from '../../../../img/user-default.png';
import { BASE_URL } from '../../../core/constants/api';

import './Header.scss';

const HeaderUserMenu: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const account = useSelector((state: RootState) => state.auth.authInfo?.account);
  const tenantId = useSelector((state: RootState) => state.auth.authInfo?.tenantId);
  const user = useSelector((state: RootState) => state.user.userInfo);
  const isSubcontractor = !!user?.userRole?.find((role) => role.name === UserRoleType.Subcontractor);
  const ToggleButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, onClick }, ref) => (
    <button
      ref={ref}
      className="header__user-menu-toggle"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
    >
      {children}
    </button>
  ));

  return (
    <Dropdown className="header__user-menu">
      <Dropdown.Toggle as={ToggleButton} id="user-menu">
        <span className="header__user-menu-name">{account?.name}</span>
        <Icon className="language-picker__icon" icon="arrow" size="extra-small" svg />
      </Dropdown.Toggle>
      <Dropdown.Menu className="header__menu" area-labelby="user-menu">
        <div className="header__user-menu-content">
          <Image
            className="internal-users__user-img"
            src={`${BASE_URL}/${user?.profilePhoto}`}
            alt="user avatar"
            onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
              e.currentTarget.src = defaultUserImage;
            }}
          />
          <div className="d-flex flex-column">
            <span className="header__user-menu-content-name">{account?.name}</span>
            <span className="header__user-menu-content-email text-truncate">{account?.username}</span>
          </div>
        </div>
        {isSubcontractor && (
          <Dropdown.Item className="header__user-menu-item" onClick={() => history.push(PROFILE)}>
            <Icon className="header__user-menu-item-icon" icon="company" size="extra-small" svg />
            {t('header.dropdown.profileSettings')}
          </Dropdown.Item>
        )}
        <Dropdown.Item className="header__user-menu-item" onClick={() => (tenantId ? dispatch(logout()) : dispatch(logoutExternal()))}>
          <Icon className="header__user-menu-item-icon" icon="logout" size="extra-small" svg />
          {t('header.dropdown.logout')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default HeaderUserMenu;
